import React, { useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';

const Layout = ({ children, userRole = 'admin', userName = 'مستخدم النظام', onQuickMenuToggle }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleSidebarToggle = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleSidebarClose = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div className="app-layout relative">
      {/* Transparent Watermark Background */}
      <div 
        className="fixed inset-0 pointer-events-none z-0"
        style={{
          backgroundImage: 'url(/assets/images/Apropapplogo-1768312867409.jpg)',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '50%',
          opacity: 0.05,
        }}
      />

      <Header 
        userRole={userRole} 
        userName={userName}
        onQuickMenuToggle={onQuickMenuToggle}
        onMenuToggle={handleSidebarToggle}
      />

      <Sidebar 
        isOpen={isSidebarOpen}
        onClose={handleSidebarClose}
        userRole={userRole}
      />

      <main className="main-content flex flex-col relative z-10">
        <div className="flex-grow">
          {children}
        </div>
        
        {/* Branding Footer */}
        {/* Removed: Powered by K Y DIGITAL SOLUTIONS footer */}
      </main>
    </div>
  );
};

export default Layout;